import { PackageTypeForm } from "@/resources/packages/PackageTypeForm";

export function PrincipleEdit() {
  return (
    <PackageTypeForm
      action="edit"
      resource="principles"
      packageType="principle"
      label="Principle"
    />
  );
}

export default PrincipleEdit;
